<div data-test="container-grafico-doughnut" class="chart-container">
    <div class="chart-canvas-wrap" *ngIf="hasData" (mousemove)="onCanvasMouseMove($event)" (mouseleave)="isSegmentHovered = false">
        <canvas data-test="grafico-doughnut" baseChart
            [data]="doughnutChartData"
            [options]="doughnutChartOptions"
            type="doughnut">
        </canvas>
        <div class="chart-center-total" [class.is-hovering-segment]="isSegmentHovered" data-test="total-grafico-doughnut">
            <span class="chart-center-label">{{ centerLabel }}</span>
            <span class="chart-center-value">{{ centerValue | moneyFormatPipe }}</span>
        </div>
    </div>
    <div class="chart-legend" data-test="legenda-grafico-doughnut" *ngIf="legendItems.length">
        <span data-test="item-legenda-grafico-doughnut" class="chart-legend-item" *ngFor="let item of legendItems; let i = index; trackBy: trackByIndex" [class.dimmed]="item.dimmed"
            [class.selected]="item.selected" [class.not-clickable]="!legendFocusEnabled" (click)="onLegendItemClick(i)">
            <span class="chart-legend-swatch" [style.background-color]="item.color"></span>{{ item.text }}
        </span>
    </div>
    <p data-test="mensagem-sem-dados-grafico-doughnut" class="no-sales" *ngIf="!hasData">{{ noDataLabel }}</p>
</div>
